import { Button, type ButtonProps as MuiButtonProps } from '@mui/material';
import { castArray } from 'lodash/fp';
import styles from './styles';

type CustomButtonProps = MuiButtonProps;

const CustomButton = ({ sx = {}, ...props }: CustomButtonProps) => (
  <Button sx={[styles.button, ...castArray(sx)]} {...props} />
);

export default CustomButton;
